import { useFormik } from "formik";
import { img10, img11, img9, success } from "../assets";
import { ButtonRegiter } from "../components/Button";
import { InputCustom } from "../components/Input";
import { useState } from "react";
import { options, url } from "../util";
import * as yup from 'yup';

const Treatment = ({ treatmentRef }) => {
  const [ok, setOk] = useState(false);
  const formik = useFormik({
    validationSchema: yup.object().shape({
      fullname: yup.string().required(),
      email: yup.string().required(),
      phoneNumber: yup.string().required(),
      age: yup.string().required(),
      income: yup.string().required(),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      fullname: "",
      email: "",
      phoneNumber: "",
      age: "",
      income: "",
      typeRegis: "1",
    },
    onSubmit: (values) => {
      fetch(url, options(values))
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json();
        })
        .then((data) => {
          setOk(true);
          setTimeout(() => {
            setOk(false);
          }, 4000);
        })
        .catch((error) => {
          console.error("error", error);
        });
    },
  });
  return (
    <div
      ref={treatmentRef}
      className="w-screen h-auto bg-[#e9f4ff] relative flex justify-center pb-[30px]"
    >
      <div className="flex flex-col items-center">
        <div className="title-1 mb-[30px] mt-[40px] flex flex-col	items-center absolute left-[50%] -translate-x-[50%]">
          <div className="text-[24px] sm:text-[28px] lg:text-[36px] font-[700] text-[#333333] text-center">
            CHẾ ĐỘ ĐÃI NGỘ
          </div>
          <div className="w-[166px] border-b-[6px] border-[#005DD7] mt-[15px]"></div>
        </div>
      </div>
      <div className="flex max-w-[1116px] justify-center pt-[140px] lg:pt-[50px] flex-wrap h-auto">
        <div className="px-[24px] sm:px-0sm:mr-[36px] sm:h-[540px]">
          <div className="flex items-center">
            <img
              className="w-[159px] h-[118px] sm:h-auto sm:w-[260px]"
              src={img9}
              alt=""
            />
            <div className="ml-[25px]">
              <div className="text-treatment">Du lịch</div>
              <div className="text-treatment-2">
                Cơ hội tham gia các chuyến du lịch nghỉ dưỡng cùng công ty
              </div>
            </div>
          </div>
          <div className="flex flex-row-reverse sm:flex-row items-center sm:mt-[-30px] sm:absolute sm:ml-[40px] sm:z-[2]">
            <img
              className="w-[159px] h-[118px] sm:h-auto sm:w-[318px]"
              src={img10}
              alt=""
            />
            <div className="mr-[25px] sm:mr-0 sm:ml-[25px] max-w-[344px]">
              <div className="text-treatment text-right sm:text-left">
                Thu nhập
              </div>
              <div className="text-treatment-2 text-right sm:text-left">
                Thu nhập không giới hạn với hoa hồng theo doanh số, thưởng nóng
                thường xuyên và thưởng theo quý, năm dựa trên thành tích
              </div>
            </div>
          </div>
          <div className="flex items-center sm:mt-[145px] sm:absolute sm:ml-[170px] sm:z-[1]">
            <img
              className="w-[159px] h-[118px] sm:h-auto sm:w-[250px]"
              src={img11}
              alt=""
            />
            <div className="ml-[25px] max-w-[280px]">
              <div className="text-treatment">Bảo hiểm</div>
              <div className="text-treatment-2">
                Nhận được thẻ chăm sóc sức khoẻ số 1 thị trường.
              </div>
            </div>
          </div>
        </div>
        <div className="mt-[25px] max-w-[346px] sm:max-w-[100vw] lg:w-[331px] p-[15px] sm:p-[25px] rounded-[20px] bg-[#ffffff] flex flex-col items-center relative">
          <div className="text-[20px] sm:text-[24px] font-[700] text-[#005dd7] mb-[20px] mt-[10px] text-center px-[30px] sm:px-0">
            Đăng ký nhận thông tin về thu nhập
          </div>
          <div className="w-[100%] flex flex-col sm:flex-row lg:flex-col gap-[20px] mb-[20px]">
            <InputCustom
              className="sm:w-[370px] lg:w-[100%]"
              placeholder={"Họ và tên"}
              onChange={(e) => {
                formik.setFieldValue("fullname", e.target.value);
              }}
              value={formik.values.fullname}
              error={formik.errors.fullname && formik.touched.fullname}
            />
            <div className="w-full flex justify-between sm:w-[370px] lg:w-[100%]">
              <InputCustom
                width={"70%"}
                placeholder={"Số điện thoại"}
                onChange={(e) => {
                  formik.setFieldValue("phoneNumber", e.target.value);
                }}
                value={formik.values.phoneNumber}
                error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              />
              <InputCustom
                width={"25%"}
                placeholder={"Tuổi"}
                onChange={(e) => {
                  formik.setFieldValue("age", e.target.value);
                }}
                value={formik.values.age}
                error={formik.errors.age && formik.touched.age}
              />
            </div>
          </div>
          <div className={`w-[100%] flex lg:flex-col gap-[20px] ${formik.isValid ? 'mb-[26px]' : 'mb-[2px]'}`}>
            <InputCustom
              width={"100%"}
              placeholder={"Email"}
              onChange={(e) => {
                formik.setFieldValue("email", e.target.value);
              }}
              value={formik.values.email}
              error={formik.errors.email && formik.touched.email}
            />
            <InputCustom
              width={"100%"}
              placeholder={"Thu nhập mong muốn"}
              onChange={(e) => {
                formik.setFieldValue("income", e.target.value);
              }}
              value={formik.values.income}
              error={formik.errors.income && formik.touched.income}
            />
          </div>
          {!formik.isValid && <div className="text-[#ff0000bf] text-[16px]">Vui lòng điền đầy đủ thông tin</div>}
          <ButtonRegiter
            onClick={() => formik.handleSubmit()}
            className="button"
            width={"100%"}
          />
          {ok && (
            <div className="absolute bg-white h-[100%] w-[100%] rounded-[20px] flex justify-center items-center top-0 left-0">
              <img src={success} alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Treatment;
